import { render, staticRenderFns } from "./MyMarkdown.vue?vue&type=template&id=39db3505"
import script from "./MyMarkdown.vue?vue&type=script&lang=js"
export * from "./MyMarkdown.vue?vue&type=script&lang=js"
import style0 from "./MyMarkdown.vue?vue&type=style&index=0&id=39db3505&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports